import SummaryCardEmptyStateComponent from './SummaryCardEmptyState.component';

export default SummaryCardEmptyStateComponent;
